import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, XCircle, Clock } from "lucide-react";
import { useApp } from "../context/AppContext";

export default function PaymentResult({ result }) {
  const { t } = useApp();
  const [params] = useSearchParams();
  const [status] = useState(result);

  const map = {
    success: { icon: CheckCircle2, color: "var(--gold)", title: t.payment.successT, desc: t.payment.successD },
    failure: { icon: XCircle, color: "#e05252", title: t.payment.failT, desc: t.payment.failD },
    pending: { icon: Clock, color: "#c9a227", title: t.payment.pendT, desc: t.payment.pendD },
  };
  const s = map[status] || map.pending;
  const Icon = s.icon;

  return (
    <div className="min-h-screen bg-[#050505] grid place-items-center px-6 pt-24 pb-16">
      <div className="max-w-lg w-full text-center border border-[var(--border)] bg-[var(--purple)]/30 p-12" data-testid={`payment-${status}`}>
        <Icon className="w-16 h-16 mx-auto mb-6" style={{ color: s.color }} />
        <h1 className="font-serif font-light text-4xl mb-4">{s.title}</h1>
        <p className="text-white/60 mb-8">{s.desc}</p>
        {params.get("booking_id") && (
          <p className="text-xs text-white/30 mb-8 tracking-wider">Ref: {params.get("booking_id")}</p>
        )}
        <Link to="/" className="btn-fill inline-flex border border-[var(--gold)] text-[var(--gold)] px-10 py-4 text-xs uppercase tracking-[0.2em] transition-colors duration-300">
          {t.payment.home}
        </Link>
      </div>
    </div>
  );
}
